<script lang="ts">
  import { page } from '$app/state'
  import { signIn } from '@auth/sveltekit/client'
  import Icon from '@iconify/svelte'
  import { fade, fly } from 'svelte/transition'
  import { Button } from '@/components/ui/button'
  import { Input } from '@/components/ui/input'

  let email: string = $state()

  function isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  let callbackUrl = $derived(page.url.searchParams.get('callbackUrl') || '/')

  let validEmail = $derived(isValidEmail(email))
</script>

<svelte:head>
  <title>Login to Coso.ai</title>
</svelte:head>

<div>
  <!-- Background decoration -->
  <div class="absolute inset-0 overflow-hidden">
    <div class="bg-primary-100/30 absolute -left-4 top-20 h-64 w-64 rounded-full blur-3xl"></div>
    <div class="bg-primary-100/40 absolute -right-8 bottom-20 h-96 w-96 rounded-full blur-3xl"></div>
  </div>

  <div class="relative flex min-h-screen items-center justify-center px-4">
    <div class="w-full max-w-md space-y-8" in:fly={{ y: 20, duration: 800 }}>
      <div class="space-y-3 text-center">
        <div class="bg-primary mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl p-1 shadow-lg">
          <img src="/assets/images/coso_logo_white_ts.svg" alt="Coso.ai logo" class="h-full w-full object-contain" />
        </div>
        <h2 class="text-4xl font-bold tracking-tight text-gray-900">Welcome to Coso.ai</h2>
        <p class="text-base text-gray-600">Sign in or create your account to get started</p>
      </div>

      <div class="mt-12 space-y-4" in:fly={{ y: 20, duration: 800, delay: 200 }}>
        <Button
          type="button"
          onclick={() => {
            signIn('google', { callbackUrl })
          }}
          variant="outline"
          class="w-full"
          size="lg"
        >
          <Icon icon="logos:google-icon" height="24" />
          <span class="font-medium text-gray-700">Sign in with Google</span>
        </Button>

        <Button
          type="button"
          onclick={() => {
            signIn('facebook', { callbackUrl })
          }}
          variant="outline"
          class="w-full"
          size="lg">
          <Icon icon="logos:meta-icon" height="24" />
          <span class="font-medium text-gray-700">Sign in with Meta</span>
        </Button>
      </div>

      <div class="relative" in:fly={{ y: 20, duration: 800, delay: 400 }}>
        <div class="absolute inset-0 flex items-center">
          <div class="w-full border-t border-gray-200"></div>
        </div>
        <div class="relative flex justify-center text-sm">
          <span class="bg-neutral px-4 text-gray-500">OR</span>
        </div>
      </div>

      <div class="space-y-4" in:fly={{ y: 20, duration: 800, delay: 600 }}>
        <Input
          type="email"
          name="email"
          placeholder="you@example.com"
          bind:value={email}
        />
        <Button
          type="button"
          onclick={() => {
            signIn('email', { callbackUrl, email }, { monkey: 'email' })
          }}
          disabled={!validEmail}
          variant="outline"
          class="w-full"
          size="lg"
        >
          <Icon icon="mdi:email" height="24" />
          <span class="font-medium text-gray-700">Sign in with Email</span>
        </Button>
      </div>

      <p class="mt-8 text-center text-sm text-gray-500" in:fade={{ delay: 800 }}>
        Start or continue your journey to better social media management
      </p>
    </div>
  </div>
</div>
